import React, { useContext } from "react";
import styles from "./index.module.scss";
import StudyProgress from "./components/StudyProgress";
import StudyBtn from "./components/StudyBtn";
import { ChapterContext } from "../../../../store";

interface ChaptersListFooter {
    percent: number;
}

export default function ChaptersListFooter({ percent }: ChaptersListFooter) {
    const { onContinue, todoResource } = useContext(ChapterContext);

    return (
        <div className={styles.root}>
            <StudyProgress percent={percent} />
            {todoResource && <StudyBtn onClick={onContinue} />}
        </div>
    );
}
